import { atom } from 'recoil';
import { CacheKeys } from 'src/constants';
import { localStorageEffect } from 'src/lib/recoil';

export const customerModeActiveState = atom<boolean>({
  key: 'customerMode/active',
  default: false,
  effects: [localStorageEffect(CacheKeys.customerModeActive)],
});
